var _path, _ellipse, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.86719 7.17728C6.86726 6.80814 6.97484 6.44612 7.17817 6.13079C7.3815 5.81546 7.67275 5.55895 8.0201 5.38931C8.36744 5.21966 8.75751 5.1434 9.14767 5.16886C9.53783 5.19432 9.91306 5.32052 10.2324 5.53368C10.5517 5.74683 10.8028 6.03873 10.9582 6.37747C11.1136 6.71621 11.1674 7.08876 11.1136 7.4544C11.0599 7.82004 10.9007 8.1647 10.6534 8.45071C10.4061 8.73672 10.0804 8.95307 9.71163 9.07611C9.50358 9.14554 9.32346 9.27417 9.1961 9.44427C9.06874 9.61437 9.00041 9.81757 9.00052 10.0259V10.7011",
    stroke: "#9EA6AA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9,
    cy: 12.9673,
    rx: 1,
    ry: 0.943878,
    fill: "#9EA6AA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 9.19165C1 11.1943 1.84285 13.1149 3.34315 14.531C4.84344 15.9471 6.87827 16.7427 9 16.7427C11.1217 16.7427 13.1566 15.9471 14.6569 14.531C16.1571 13.1149 17 11.1943 17 9.19165C17 7.18899 16.1571 5.26836 14.6569 3.85227C13.1566 2.43618 11.1217 1.64063 9 1.64062C6.87827 1.64063 4.84344 2.43618 3.34315 3.85227C1.84285 5.26836 1 7.18899 1 9.19165V9.19165Z",
    stroke: "#9EA6AA",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/questionMark.32c7b24eae68a8ebe8438da420fcaf56.svg";
export { ForwardRef as ReactComponent };